import { FC } from 'react';
import styled, { css } from 'styled-components';
import LayeredIcons, { IconProps } from './LayeredIcons';
import { nameof } from '../../utils/stringUtils';

const Text = styled.span`
  padding-bottom: 4px;
`;

interface IProps {
  className?: undefined;
  icons: IconProps[];
  text: string | number | boolean;
  color?: string | { icon?: string, text?: string };
}

const RawIconAndText: FC<IProps> = ({ className, icons, text }) => (
  <div className={className}>
    <LayeredIcons icons={icons} fontSize={'1.5em'} />
    <Text className="value-text">{text}</Text>
  </div>
);
RawIconAndText.displayName = nameof({ RawIconAndText });

const IconAndText = styled(RawIconAndText)`
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  font-size: 1.75rem;

  ${p => {
    if (p.color) {
      if (typeof p.color === 'object') {
        return css`
          & > div { color: ${p.color.icon ?? 'inherit'}; }
          & > span { color: ${p.color.text ?? 'inherit'}; }
        `;
      }
      else {
        return css`color: ${p.color};`;
      }
    }
    else {
      return css`color: inherit;`;
    }
  }}
`;

export default IconAndText;